import React, { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import { getTasksList } from '../../store/Tasks/Task/taskSlice';
import { useTranslation } from 'react-i18next';

const useGetTasksList = () => {
  const dispatch = useAppDispatch();

  const { i18n, t } = useTranslation();
  const { TasksList, loading, error } = useAppSelector(state => state.Tasks);

  useEffect(() => {
    if (TasksList?.length === 0) {
      dispatch(getTasksList());
    }
  }, [TasksList?.length, dispatch]);

  const OptionsTasks = TasksList?.map(item => ({
    value: item.id,
    label: i18n.language === 'en' ? item.name : item.name2
  }));

  return { TasksList, OptionsTasks, loading, error };
};

export default useGetTasksList;
